import React from 'react'

interface NumericInputIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const NumericInputIcon: React.FC<NumericInputIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 12,
  alt = 'Numeric input icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 12'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M3.976 11.52h-1.27v-9.6h-.03L.756 3.632 0 2.656 2.872.192h1.104V11.52zM7.75 9.984l4.037-4.16c.252-.256.474-.49.665-.704.192-.224.348-.437.47-.64.13-.213.226-.432.286-.656.06-.224.091-.475.091-.752 0-.299-.05-.565-.151-.8a1.64 1.64 0 00-.423-.592 1.636 1.636 0 00-.62-.384 1.956 1.956 0 00-.756-.144c-.544 0-.993.165-1.346.496-.352.33-.58.768-.68 1.312l-1.376-.128c.07-.459.202-.864.393-1.216A3 3 0 019.081.72c.302-.235.64-.41 1.013-.528A3.702 3.702 0 0111.304 0c.443 0 .861.07 1.254.208.393.128.736.32 1.028.576.303.256.54.576.71.96.182.384.273.827.273 1.328 0 .448-.06.853-.181 1.216-.111.363-.268.699-.47 1.008a6.512 6.512 0 01-.664.864c-.242.267-.5.533-.771.8l-3.296 3.28v.032h5.458v1.248H7.75V9.984zM19.54 4.992h.393c.262 0 .534-.021.817-.064.292-.043.554-.133.786-.272a1.61 1.61 0 00.59-.592c.16-.267.241-.613.241-1.04 0-.576-.171-1.03-.514-1.36-.332-.341-.77-.512-1.315-.512-.454 0-.847.107-1.18.32-.332.213-.594.528-.785.944l-1.225-.496c.262-.64.67-1.12 1.225-1.44.564-.32 1.189-.48 1.874-.48.424 0 .827.064 1.21.192.393.128.735.315 1.028.56.292.245.524.555.695.928.172.363.257.79.257 1.28 0 .597-.171 1.136-.514 1.616-.332.47-.77.795-1.315.976v.032c.343.064.645.181.907.352.272.17.504.384.695.64.192.245.338.528.439.848.1.32.151.656.151 1.008 0 .544-.096 1.019-.287 1.424a3.049 3.049 0 01-.771 1.024c-.323.277-.7.485-1.134.624a4.294 4.294 0 01-1.346.208c-.816 0-1.527-.187-2.131-.56-.605-.373-1.044-.981-1.316-1.824L18.3 8.88c.182.608.439 1.04.771 1.296.333.256.797.384 1.391.384.303 0 .585-.053.847-.16a2.03 2.03 0 00.68-.448 2.17 2.17 0 00.469-.704c.12-.277.181-.581.181-.912 0-.416-.08-.763-.241-1.04a1.687 1.687 0 00-.62-.672 2.544 2.544 0 00-.862-.368 4.343 4.343 0 00-.983-.112h-.393V4.992z'
      />
    </svg>
  )
}

export default NumericInputIcon
